module.exports = __webpack_public_path__ + "img/inquiry_odd.489a0d91.svg";